import { UtilsApi } from '../../http/api/utils.api';
import { LocalNotifications } from '@capacitor/local-notifications';
import {FirebaseMessaging}  from "@capacitor-firebase/messaging"
import { registerPlugin, Capacitor } from '@capacitor/core';

const requestPermission = async () => {
    return await FirebaseMessaging.requestPermissions()
};

// Call the function to request permission


// Регистрация для push-уведомлений
export const registerPush = async (profile_id: number) => {

    await LocalNotifications.registerActionTypes({
    types: [
        {
        id: 'MESSAGE_ACTIONS',
        actions: [
            {
            id: 'Yes',
            title: 'Подтвердить',
            },
            {
            id: 'No',
            title: 'Отклонить',
            }
        ]
        }
    ]
    });

    const permission = await requestPermission()
    console.log("Status - ", permission.receive === "granted")

    if (Capacitor.isNativePlatform() && permission.receive === "granted") {

        FirebaseMessaging.getToken().then((res: { token: string }) => {
            console.log("Token received", res.token);
            localStorage.setItem("FCMToken", res.token);
            UtilsApi.SendNotificationToken({ fcm_token: res.token, user_id: profile_id });
        });
        
        
        LocalNotifications.addListener('localNotificationActionPerformed', (notification: any) => {
            const actionId = notification.actionId;
            if (actionId === 'Yes') {
                console.log(JSON.stringify(notification, null, 2))
                UtilsApi.ConfirmOrder({order_id: notification.data.order_id, confirm: true})
            }
        });

        FirebaseMessaging.addListener('notificationActionPerformed', (notification: any) => {
            if (notification.actionId === 'Yes') {
                console.log(JSON.stringify(notification, null, 2))
                UtilsApi.ConfirmOrder({order_id: notification.data.order_id, confirm: true})
            }
        })
        
        if(Capacitor.getPlatform() === 'android'){

            const NativeFirebaseMessaging = registerPlugin<any>('NativeFirebaseMessaging')

            NativeFirebaseMessaging.addListener('onMessageReceived', async (message: any) => {
            console.log('New message received:', JSON.stringify(message, null, 2));
            let imgSrc = message.data.type === "bonus" ? 'ic_heart' : 'ic_analisys'
            await LocalNotifications.schedule({
                    notifications:[
                        {
                            title: message.data.title || message.notification.title || 'Новое уведомление',
                            body: message.data.body || message.notification.body ||'У вас новое сообщение',
                            id: Math.floor(Math.random() * 1000), // Убедитесь, что ID уникален
                            channelId: 'default',
                            largeIcon: imgSrc,
                            smallIcon: "ic_stat_group_38",
                            iconColor: '#FFCF00',
                            actionTypeId: message.data.action === "confirm" ? "MESSAGE_ACTIONS" : "",
                        },
                    ],
                });
            });
        
            NativeFirebaseMessaging.addListener('onNewToken', ({token}: any) => {
                UtilsApi.SendNotificationToken({ fcm_token: token, user_id: profile_id });
            });
        }

        
        FirebaseMessaging.addListener('notificationReceived', async (event) => {
            console.log('Foreground push received:', JSON.stringify(event.notification));
            // Отображаем его как локальное уведомление немедленно
           
            let data: any = event.notification.data

            let imgSrc = data.type === "bonus" ? 'ic_heart' : 'ic_analisys'

            if (data.actions) {
                console.log("ACTIONS DATA", JSON.stringify(data.actions, null, 2))
            }

           


            await LocalNotifications.schedule({
                notifications:[
                    {
                        title: event.notification.title || 'Новое уведомление',
                        body: event.notification.body || 'У вас новое сообщение',
                        id: Math.floor(Math.random() * 1000), // Убедитесь, что ID уникален
                        channelId: 'default',
                        largeIcon: imgSrc,
                        smallIcon: "ic_stat_group_38",
                        iconColor: '#FFCF00',
                        actionTypeId: data.action === "confirm" ? "MESSAGE_ACTIONS" : "",
                    },
                ],
            });
        });
    }
};

